export default "__VITE_ASSET__vaKbrcqd__"